import { useEffect, useState } from 'react';
import { Box, Card, Grid, IconButton, Typography, useTheme } from '@mui/material'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { PhotoConsumer } from 'react-photo-view';
import ReactPlayer from 'react-player'
import { saveAs } from 'file-saver';
import AuxiliarFunction from '../../../function/AuxiliarFunction';
import DownloadFile from '../../../services/downloadFile.service';
import { ButtonBasic } from '../../../components';
import AddIcon from '@mui/icons-material/Add';
import { showModal } from 'react-redux-modal-provider';
import ModalDocumentacionAdj from '../../../modals/contacto/ModalDocumentacionAdj';

const TabCuentaDocumentacion = ({infoIni, filesAdj,token,onGuardar,consulta}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [imgArrSelect, setImgArrSelect] = useState([]);
    const [archiveSelect, setArchiveSelect] = useState(null);
    const [mimeArchive, setMimeArchive] = useState(null);
    const permitidosAdd = [
        'DNI Frente',
        'DNI Dorso',
        'Constancia AFIP',
        'Contrato Social-Estatuto',
        'Acta Actualizada',
        'Poder-Apoderado',
        'Dni-Frente-Apoderado',
        'Dni-Dorso-Apoderado'
    ];
    const urlNubi = 'https://zeta.strongsystems.com.ar:8000/api/img?url='
    useEffect(() => {
        if(archiveSelect?.pathFile_facon){
            const tipe = archiveSelect?.pathFile_facon?.split('.');
            if(tipe?.length > 0){
                setMimeArchive(tipe[tipe?.length - 1])
            }else{
                setMimeArchive('NoExiste')
            }
        }else{
            setMimeArchive('NoExiste')
        }
    }, [archiveSelect])

    useEffect(() => {
        setImgArrSelect([])
        const form = {
            lugarAdjuntado_facon: 'DNI Frente',
            nombreFile_facon: infoIni?.pathFrente_icon,
        }
        if(infoIni?.pathFrente_icon){
            form.pathFile_facon = `contacto/${infoIni?.pathFrente_icon}`
        }else{
            form.pathFile_facon = null
        }
        setArchiveSelect(form)
    }, [])

    const onSelectViewImg = (nombre) =>{
        switch (nombre) {
            case 'DNIFRENTE':
                setImgArrSelect([])
                const form = {
                    lugarAdjuntado_facon: 'DNI Frente',
                    nombreFile_facon: infoIni?.pathFrente_icon,
                }
                if(infoIni?.pathFrente_icon){
                    form.pathFile_facon = `contacto/${infoIni?.pathFrente_icon}`
                }else{
                    form.pathFile_facon = null
                }
                setArchiveSelect(form)
                break;
            case 'DNIDORSO':
                setImgArrSelect([])
                const form2 = {
                    lugarAdjuntado_facon: 'DNI Dorso',
                    nombreFile_facon: infoIni?.pathDorso_icon,
                }
                if(infoIni?.pathDorso_icon){
                    form2.pathFile_facon = `contacto/${infoIni?.pathDorso_icon}`
                }else{
                    form2.pathFile_facon = null
                }
                setArchiveSelect(form2)
                break;
            case 'CONSTANCIA':
                setImgArrSelect([])
                const form3 = {
                    lugarAdjuntado_facon: 'Constancia AFIP',
                    nombreFile_facon: infoIni?.pathconstanciaAfip_icon,
                }
                if(infoIni?.pathconstanciaAfip_icon){
                    form3.pathFile_facon = `contacto/${infoIni?.pathconstanciaAfip_icon}`
                }else{
                    form3.pathFile_facon = null
                }
                setArchiveSelect(form3)
                break;
            case 'SOCIAL-ESTATUTO':
                setImgArrSelect([])
                const form4 = {
                    lugarAdjuntado_facon: 'Contrato Social-Estatuto',
                    nombreFile_facon: infoIni?.pathContratoSocialEstatuto_icon,
                }
                if(infoIni?.pathContratoSocialEstatuto_icon){
                    form4.pathFile_facon = `contacto/${infoIni?.pathContratoSocialEstatuto_icon}`
                }else{
                    form4.pathFile_facon = null
                }
                setArchiveSelect(form4)
                break;
            /* case 'ACTA ACTUALIZADA':
                setImgArrSelect([])
                const form5 = {
                    lugarAdjuntado_facon: 'Acta Actualizada',
                    nombreFile_facon: infoIni?.pathDesigActaActualizada_icon,
                }
                if(infoIni?.pathDesigActaActualizada_icon){
                    form5.pathFile_facon = `contacto/${infoIni?.pathDesigActaActualizada_icon}`
                }else{
                    form5.pathFile_facon = null
                }
                setArchiveSelect(form5)
                break; */
            case 'PODER-APODERADO':
                setImgArrSelect([])
                const form6 = {
                    lugarAdjuntado_facon: 'Poder-Apoderado',
                    nombreFile_facon: infoIni?.pathPoderApoderado_icon,
                }
                if(infoIni?.pathPoderApoderado_icon){
                    form6.pathFile_facon = `contacto/${infoIni?.pathPoderApoderado_icon}`
                }else{
                    form6.pathFile_facon = null
                }
                setArchiveSelect(form6)
                break;
            case 'DNI-FRENTE-APODERADO':
                setImgArrSelect([])
                const form7 = {
                    lugarAdjuntado_facon: 'Dni-Frente-Apoderado',
                    nombreFile_facon: infoIni?.pathDniFrenteApoderado_icon,
                }
                if(infoIni?.pathDniFrenteApoderado_icon){
                    form7.pathFile_facon = `contacto/${infoIni?.pathDniFrenteApoderado_icon}`
                }else{
                    form7.pathFile_facon = null
                }
                setArchiveSelect(form7)
                break;
            case 'DNI-DORSO-APODERADO':
                setImgArrSelect([])
                const form8 = {
                    lugarAdjuntado_facon: 'Dni-Dorso-Apoderado',
                    nombreFile_facon: infoIni?.pathDniDorsoApoderado_icon,
                }
                if(infoIni?.pathDniDorsoApoderado_icon){
                    form8.pathFile_facon = `contacto/${infoIni?.pathDniDorsoApoderado_icon}`
                }else{
                    form8.pathFile_facon = null
                }
                setArchiveSelect(form8)
                break;
            case 'VACIAR':
                setImgArrSelect([])
                setArchiveSelect(null)
                break;
            default:
                if(filesAdj[nombre] && filesAdj[nombre]?.length > 1){
                    setImgArrSelect(filesAdj[nombre])
                    setArchiveSelect(filesAdj[nombre][0])
                }
                if(filesAdj[nombre] && filesAdj[nombre]?.length === 1){
                    setArchiveSelect(filesAdj[nombre][0])
                    setImgArrSelect(filesAdj[nombre])
                }
                break;
        }
    }

    const descargarFile = async() =>{
        if(archiveSelect?.pathFile_facon){
            await AuxiliarFunction.downloadFile(DownloadFile.fileNubi({id:archiveSelect?.pathFile_facon}),archiveSelect?.nombreFile_facon)
        }
    }

    const onOpenModalAddDocumentacion = () =>{
        showModal(ModalDocumentacionAdj,{archiveSelect: archiveSelect, onGuardar: onGuardar,consulta: consulta, onSelectViewImg:onSelectViewImg })
    }
    return (
        <Card sx={{background: isDarkMode ? '#2d3a52 !important' : '#fff !important', p: {xs: 0.5, md: 1}, boxShadow: 4, border: isDarkMode ? '1px solid #3d4a62' : 'none'}}>
            <Grid container>
                {/* Sidebar: vertical en desktop, horizontal scrollable en mobile */}
                <Grid item xs={12} md={2}>
                    {/* Header */}
                    <Box sx={{
                        width: '100%',
                        height: 44,
                        border: 1,
                        borderColor: isDarkMode ? '#3d4a62' : 'gray',
                        display: {xs: 'none', md: 'flex'},
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: isDarkMode ? '#1F2A40' : 'transparent',
                        borderRadius: {md: '8px 8px 0 0'},
                    }}>
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b', fontWeight: 'bold', fontSize: {xs: 12, md: 14}}}>Adjuntos</Typography>
                    </Box>
                    {/* Items container */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: {xs: 'row', md: 'column'},
                        overflowX: {xs: 'auto', md: 'visible'},
                        overflowY: {xs: 'hidden', md: 'visible'},
                        pb: {xs: 0.5, md: 0},
                        gap: {xs: 0.5, md: 0},
                        '&::-webkit-scrollbar': {
                            height: 4,
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: isDarkMode ? '#3d4a62' : '#c0c0c0',
                            borderRadius: 2,
                        },
                    }}>
                        {[
                            { label: 'DNI Frente', action: 'DNIFRENTE' },
                            { label: 'DNI Dorso', action: 'DNIDORSO' },
                            { label: 'Constancia AFIP', action: 'CONSTANCIA' },
                            { label: 'Contrato Social-Estatuto', action: 'SOCIAL-ESTATUTO' },
                            { label: 'Acta Actualizada', action: 'ACTA ACTUALIZADA' },
                            { label: 'Poder-Apoderado', action: 'PODER-APODERADO' },
                            { label: 'Dni-Frente-Apoderado', action: 'DNI-FRENTE-APODERADO' },
                            { label: 'Dni-Dorso-Apoderado', action: 'DNI-DORSO-APODERADO' },
                        ].map((item) => {
                            const isActive = item.label === archiveSelect?.lugarAdjuntado_facon;
                            return (
                                <Box
                                    key={item.action}
                                    sx={{
                                        minWidth: {xs: 'max-content', md: '100%'},
                                        width: {md: '100%'},
                                        height: {xs: 38, md: 44},
                                        border: {xs: 'none', md: 1},
                                        borderColor: isDarkMode ? '#3d4a62' : 'gray',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        px: {xs: 1.5, md: 1},
                                        borderRadius: {xs: '8px', md: 0},
                                        transition: 'all 0.15s ease',
                                        background: isActive
                                            ? (isDarkMode ? '#1a3a5c' : '#e6f0ff')
                                            : (isDarkMode ? '#1F2A40' : '#fff'),
                                        color: isActive
                                            ? (isDarkMode ? '#90caf9' : '#15294b')
                                            : (isDarkMode ? '#b0bec5' : '#6b788e'),
                                        ...(
                                            {xs: {
                                                border: isActive
                                                    ? `1.5px solid ${isDarkMode ? '#90caf9' : '#0364ff'}`
                                                    : `1px solid ${isDarkMode ? '#3d4a62' : '#dce1e8'}`,
                                            }}
                                        ),
                                        '&:hover': {
                                            background: isDarkMode ? '#1a3a5c' : '#e6f0ff',
                                            color: isDarkMode ? '#90caf9' : '#15294b',
                                        },
                                    }}
                                    onClick={() => onSelectViewImg(item.action)}
                                >
                                    <Typography sx={{fontWeight: 'bold', fontSize: {xs: 11, sm: 12, md: 13}, whiteSpace: 'nowrap'}}>{item.label}</Typography>
                                </Box>
                            );
                        })}
                        {filesAdj && Object.keys(filesAdj).length > 0 && (
                            Object.keys(filesAdj).map((fileKey) => {
                                const isActive = fileKey === imgArrSelect[0]?.lugarAdjuntado_facon || fileKey === archiveSelect?.lugarAdjuntado_facon;
                                return (
                                    <Box
                                        key={fileKey}
                                        sx={{
                                            minWidth: {xs: 'max-content', md: '100%'},
                                            width: {md: '100%'},
                                            height: {xs: 38, md: 44},
                                            border: {xs: 'none', md: 1},
                                            borderColor: isDarkMode ? '#3d4a62' : 'gray',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            px: {xs: 1.5, md: 1},
                                            borderRadius: {xs: '8px', md: 0},
                                            transition: 'all 0.15s ease',
                                            background: isActive
                                                ? (isDarkMode ? '#1a3a5c' : '#e6f0ff')
                                                : (isDarkMode ? '#1F2A40' : '#fff'),
                                            color: isActive
                                                ? (isDarkMode ? '#90caf9' : '#15294b')
                                                : (isDarkMode ? '#b0bec5' : '#6b788e'),
                                            ...(
                                                {xs: {
                                                    border: isActive
                                                        ? `1.5px solid ${isDarkMode ? '#90caf9' : '#0364ff'}`
                                                        : `1px solid ${isDarkMode ? '#3d4a62' : '#dce1e8'}`,
                                                }}
                                            ),
                                            '&:hover': {
                                                background: isDarkMode ? '#1a3a5c' : '#e6f0ff',
                                                color: isDarkMode ? '#90caf9' : '#15294b',
                                            },
                                        }}
                                        onClick={() => onSelectViewImg(fileKey)}
                                    >
                                        <Typography sx={{fontWeight: 'bold', fontSize: {xs: 11, sm: 12, md: 13}, whiteSpace: 'nowrap'}}>{fileKey}</Typography>
                                    </Box>
                                );
                            })
                        )}
                    </Box>
                </Grid>
                {/* Content area */}
                <Grid item xs={12} md={10}>
                    {/* Toolbar header */}
                    <Box sx={{
                        width: '100%',
                        minHeight: {xs: 44, md: 50},
                        border: 1,
                        borderColor: isDarkMode ? '#3d4a62' : 'gray',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: isDarkMode ? '#1F2A40' : 'transparent',
                        flexWrap: {xs: 'wrap', sm: 'nowrap'},
                        px: {xs: 0.5, md: 0},
                        py: {xs: 0.5, sm: 0},
                        gap: {xs: 0.5, sm: 0},
                    }}>
                        <Box sx={{display: 'flex', alignItems: 'center', minWidth: 0, flex: 1}}>
                            <Typography sx={{
                                color: isDarkMode ? '#e0e0e0' : '#15294b',
                                fontWeight: 'bold',
                                ml: 1,
                                fontSize: {xs: 12, sm: 14},
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>{archiveSelect?.nombreFile_facon || '-'}</Typography>
                        </Box>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                            {(permitidosAdd.includes(archiveSelect?.lugarAdjuntado_facon)) && (
                                <ButtonBasic
                                    textButton='Agregar'
                                    iconStart={<AddIcon />}
                                    variant='wk'
                                    color='nextWhite'
                                    sx={{mr: 0.5, color: isDarkMode ? '#90caf9' : '#15294b', borderColor: isDarkMode ? '#90caf9' : '#15294b', border: 1, fontSize: {xs: 11, sm: 14}}}
                                    onClick={() => onOpenModalAddDocumentacion(archiveSelect)}
                                />
                            )}
                            <IconButton sx={{boxShadow: 4, mr: 1, bgcolor: isDarkMode ? '#2d3a52' : undefined}} onClick={() => descargarFile()}>
                                <SaveAltIcon sx={{color: isDarkMode ? '#90caf9' : '#15294b', fontSize: {xs: 20, md: 24}}} />
                            </IconButton>
                        </Box>
                    </Box>
                    {/* Preview area */}
                    <Box sx={{height: {xs: 200, sm: 250, md: 290}, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        {archiveSelect && mimeArchive && (
                            <>
                                {(mimeArchive === 'jpg' || mimeArchive === 'png' || mimeArchive === 'jpeg' || mimeArchive === 'svg' || mimeArchive === 'x-png')  && (
                                    <PhotoConsumer
                                        key={`IMG${archiveSelect.pathFile_facon}`}
                                        src={`${urlNubi}${archiveSelect.pathFile_facon}&token=${token}`}
                                        intro={archiveSelect.pathFile_facon}
                                    >
                                        <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                                            <img
                                                src={`${urlNubi}${archiveSelect.pathFile_facon}&token=${token}`}
                                                alt={archiveSelect.nombreFile_facon || 'preview'}
                                                style={{maxWidth: '90%', maxHeight: '100%', objectFit: 'contain', borderRadius: 6}}
                                            />
                                        </Box>
                                    </PhotoConsumer>
                                )}
                                {(mimeArchive === 'wmv' || mimeArchive === 'mp4' || mimeArchive === 'avi' || mimeArchive === 'mov') && (
                                    <ReactPlayer
                                        key={`Video${archiveSelect?.pathFile_facon}`}
                                        url={`${urlNubi}${archiveSelect?.pathFile_facon}&token=${token}`}
                                        width='100%'
                                        height='100%'
                                        controls
                                    />
                                )}
                                {mimeArchive === 'pdf' && (
                                    <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <img src='/img/pdf.png' alt='PDF' style={{width: 120, height: 120, objectFit: 'contain'}} />
                                    </Box>
                                )}
                                {(mimeArchive === 'doc' || mimeArchive === 'docx') && (
                                    <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <img src='/img/doc.png' alt='DOC' style={{width: 120, height: 120, objectFit: 'contain'}} />
                                    </Box>
                                )}
                                {(mimeArchive === 'xls' || mimeArchive === 'xlsx') && (
                                    <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <img src='/img/xls.png' alt='XLS' style={{width: 120, height: 120, objectFit: 'contain'}} />
                                    </Box>
                                )}
                                {mimeArchive === 'txt' && (
                                    <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <img src='/img/txt.png' alt='TXT' style={{width: 120, height: 120, objectFit: 'contain'}} />
                                    </Box>
                                )}
                                {mimeArchive === 'NoExiste' && (
                                    <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                        <img src='/img/sin_datos.jpg' alt='Sin Imagen' style={{maxWidth: '80%', maxHeight: '100%', objectFit: 'contain'}} />
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 1}}>
                        {imgArrSelect?.length > 1 && (
                            <>
                                <Typography sx={{
                                    color: isDarkMode ? '#90caf9' : '#0364ff',
                                    fontWeight: 600,
                                    fontSize: 12,
                                    mb: 1,
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase',
                                }}>
                                    {`${imgArrSelect.length} archivos adjuntos`}
                                </Typography>
                                <Box sx={{width: {xs: '90%', sm: '80%', md: 420, lg: 500}, maxWidth: '100%'}}>
                                    <Card sx={{
                                        background: isDarkMode
                                            ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                                            : 'linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 100%)',
                                        p: 1.5,
                                        borderRadius: '12px',
                                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #dce1e8',
                                        boxShadow: isDarkMode
                                            ? '0 4px 12px rgba(0,0,0,0.3)'
                                            : '0 4px 12px rgba(0,0,0,0.08)',
                                        '& .react-multi-carousel-list': {
                                            py: 0.5,
                                        },
                                        '& .react-multiple-carousel__arrow': {
                                            background: isDarkMode ? '#3d4a62' : '#fff',
                                            boxShadow: isDarkMode
                                                ? '0 2px 8px rgba(0,0,0,0.4)'
                                                : '0 2px 8px rgba(0,0,0,0.15)',
                                            minWidth: 30,
                                            minHeight: 30,
                                            borderRadius: '50%',
                                            '&::before': {
                                                color: isDarkMode ? '#90caf9' : '#0364ff',
                                                fontSize: '14px',
                                            },
                                            '&:hover': {
                                                background: isDarkMode ? '#4a5a72' : '#e6f0ff',
                                            },
                                        },
                                        '& .react-multiple-carousel__arrow--left': {
                                            left: 2,
                                        },
                                        '& .react-multiple-carousel__arrow--right': {
                                            right: 2,
                                        },
                                    }}>
                                        <Carousel
                                            additionalTransfrom={0}
                                            arrows
                                            autoPlaySpeed={3000}
                                            centerMode={false}
                                            draggable
                                            focusOnSelect={false}
                                            infinite={false}
                                            keyBoardControl
                                            minimumTouchDrag={80}
                                            pauseOnHover
                                            renderArrowsWhenDisabled={false}
                                            renderButtonGroupOutside={false}
                                            renderDotsOutside={false}
                                            responsive={{
                                                desktop: {
                                                    breakpoint: { max: 3000, min: 1024 },
                                                    items: 3,
                                                    partialVisibilityGutter: 0
                                                },
                                                tablet: {
                                                    breakpoint: { max: 1024, min: 464 },
                                                    items: 2,
                                                    partialVisibilityGutter: 0
                                                },
                                                mobile: {
                                                    breakpoint: { max: 464, min: 0 },
                                                    items: 1,
                                                    partialVisibilityGutter: 0
                                                }
                                            }}
                                            rewind={false}
                                            rewindWithAnimation={false}
                                            rtl={false}
                                            shouldResetAutoplay
                                            showDots={false}
                                            slidesToSlide={1}
                                            swipeable
                                        >
                                            {imgArrSelect?.map((fot) => {
                                                let urlNew = `${urlNubi}${fot?.pathFile_facon}&token=${token}`;
                                                const tipe = fot?.pathFile_facon?.split('.');
                                                const isSelected = archiveSelect?.id_facon === fot?.id_facon
                                                    || archiveSelect?.pathFile_facon === fot?.pathFile_facon;
                                                if (tipe?.length > 0) {
                                                    const ext = tipe[tipe.length - 1]?.toLowerCase();
                                                    if (['wmv','mp4','avi','mov'].includes(ext)) urlNew = '/img/tarjeta-tarea.png';
                                                    if (ext === 'pdf') urlNew = '/img/pdf.png';
                                                    if (['doc','docx'].includes(ext)) urlNew = '/img/doc.png';
                                                    if (['xls','xlsx'].includes(ext)) urlNew = '/img/xls.png';
                                                    if (ext === 'txt') urlNew = '/img/txt.png';
                                                    return (
                                                        <Box
                                                            key={fot?.id_facon}
                                                            onClick={() => setArchiveSelect(fot)}
                                                            sx={{
                                                                mx: 0.5,
                                                                cursor: 'pointer',
                                                                borderRadius: '10px',
                                                                overflow: 'hidden',
                                                                border: isSelected
                                                                    ? `2px solid ${isDarkMode ? '#90caf9' : '#0364ff'}`
                                                                    : `1px solid ${isDarkMode ? '#3d4a62' : '#dce1e8'}`,
                                                                background: isDarkMode ? '#2d3a52' : '#fff',
                                                                height: 100,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                transition: 'all 0.2s ease',
                                                                transform: isSelected ? 'scale(1.03)' : 'scale(1)',
                                                                boxShadow: isSelected
                                                                    ? (isDarkMode ? '0 0 12px rgba(144,202,249,0.3)' : '0 0 12px rgba(3,100,255,0.25)')
                                                                    : '0 1px 4px rgba(0,0,0,0.06)',
                                                                '&:hover': {
                                                                    transform: 'scale(1.05)',
                                                                    boxShadow: isDarkMode
                                                                        ? '0 4px 16px rgba(144,202,249,0.25)'
                                                                        : '0 4px 16px rgba(3,100,255,0.2)',
                                                                    borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                                                                },
                                                            }}
                                                        >
                                                            <img
                                                                src={urlNew}
                                                                alt='preview'
                                                                style={{
                                                                    maxWidth: '90%',
                                                                    maxHeight: '90%',
                                                                    objectFit: 'contain',
                                                                    borderRadius: 6,
                                                                }}
                                                            />
                                                        </Box>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </Carousel>
                                    </Card>
                                </Box>
                            </>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    )
}

export default TabCuentaDocumentacion